export default "__VITE_ASSET__l88G3Yl1__"